(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let observer;
    let frame = 0;
    let footers = [];

    function update() {
      frame = 0;
      footers.forEach(({ content, newsletter }) => {
        const width = newsletter?.getBoundingClientRect().width || 0;
        if (width > 0) {
          const value = `${width}px`;
          if (content.style.getPropertyValue('--tptc-footer-newsletter-width') !== value) {
            content.style.setProperty('--tptc-footer-newsletter-width', value);
          }
        } else {
          content.style.removeProperty('--tptc-footer-newsletter-width');
        }
      });
    }

    function scheduleUpdate() {
      if (!frame) frame = requestAnimationFrame(update);
    }

    function bind() {
      observer?.disconnect();
      footers = Array.from(document.querySelectorAll('.footer-content--newsletter-aligned')).map(content => {
        const group = content.closest('footer, #footer-group, .footer-group');
        const newsletter = group?.querySelector('.tptc-footer-newsletter__inner');
        return { content, newsletter };
      });
      observer = new ResizeObserver(scheduleUpdate);
      footers.forEach(({ newsletter }) => {
        if (newsletter) observer.observe(newsletter);
      });
      scheduleUpdate();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind, { once: true });
    } else {
      bind();
    }
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    document.addEventListener('shopify:section:load', bind);
    document.addEventListener('shopify:section:unload', bind);
    document.addEventListener('shopify:section:reorder', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tptc-back-to-top"]) return;
  try {
    
  if (!customElements.get('tptc-section-arrows-v2')) {
    customElements.define('tptc-section-arrows-v2', class extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
        this.isHome = this.dataset.pageType === 'index';
        this.main = document.querySelector('#MainContent');
        if (!this.main) { this.hidden = true; return; }
        this.buttons = Array.from(this.querySelectorAll('button[data-direction]'));
        this.positions = [];
        this.frame = 0;
        this.measureFrame = 0;
        this.animation = 0;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.onScroll = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
        };
        this.onMeasure = () => {
          if (!this.measureFrame) this.measureFrame = requestAnimationFrame(() => {
            this.measureFrame = 0;
            this.measure();
          });
        };
        this.onClick = (event) => {
          const button = event.target.closest('button[data-direction]');
          if (!button || this.animation) return;
          this.measure();
          if (button.disabled) return;
          const target = this.next(Number(button.dataset.direction));
          if (target !== undefined) this.go(target);
        };
        this.onInterrupt = () => this.stop();
        this.addEventListener('click', this.onClick);
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
        window.addEventListener('resize', this.onMeasure, { passive: true });
        window.addEventListener('wheel', this.onInterrupt, { passive: true });
        window.addEventListener('touchstart', this.onInterrupt, { passive: true });
        document.addEventListener('shopify:section:load', this.onMeasure);
        this.onUnload = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.remove();
          else this.onMeasure();
        };
        document.addEventListener('shopify:section:unload', this.onUnload);
        document.addEventListener('shopify:section:reorder', this.onMeasure);
        this.resizeObserver = new ResizeObserver(this.onMeasure);
        this.resizeObserver.observe(this.main);
        this.measure();
        this.onMeasure();
      }
      disconnectedCallback() {
        if (!this.onScroll) return;
        this.stop();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.measureFrame);
        this.resizeObserver?.disconnect();
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('scroll', this.onScroll, true);
        window.removeEventListener('resize', this.onMeasure);
        window.removeEventListener('wheel', this.onInterrupt);
        window.removeEventListener('touchstart', this.onInterrupt);
        document.removeEventListener('shopify:section:load', this.onMeasure);
        document.removeEventListener('shopify:section:unload', this.onUnload);
        document.removeEventListener('shopify:section:reorder', this.onMeasure);
      }
      getScroller() {
        let node = this.main.parentElement;
        while (node && node !== document.body && node !== document.documentElement) {
          if (/(auto|scroll)/.test(getComputedStyle(node).overflowY) && node.scrollHeight > node.clientHeight + 2) return node;
          node = node.parentElement;
        }
        return document.scrollingElement || document.documentElement;
      }
      topOf(element) {
        const origin = this.scroller === document.scrollingElement || this.scroller === document.documentElement
          ? 0 : this.scroller.getBoundingClientRect().top + this.scroller.clientTop;
        return this.scroller.scrollTop + element.getBoundingClientRect().top - origin;
      }
      measure() {
        const nextScroller = this.getScroller();
        if (this.scroller && this.scroller !== nextScroller) this.stop();
        this.scroller = nextScroller;
        if (!this.isHome) {
          this.heroStart = -1;
          this.heroEnd = -1;
          this.positions = [0];
          this.update();
          return;
        }
        const children = Array.from(this.main.children).filter((node) => node instanceof HTMLElement && node.classList.contains('shopify-section') && !node.hidden && !node.classList.contains('tptc-stack-skip') && getComputedStyle(node).display !== 'none' && node.getBoundingClientRect().height > 8);
        const maximum = Math.max(0, this.scroller.scrollHeight - this.scroller.clientHeight);
        const mainTop = this.topOf(this.main);
        let points;
        if (this.main.classList.contains('tptc-fabric-stack')) {
          const height = parseFloat(this.main.style.getPropertyValue('--tptc-panel-height')) || this.scroller.clientHeight;
          const panels = children.filter((node) => node.classList.contains('tptc-stack-panel'));
          this.heroEnd = mainTop + height;
          this.heroStart = mainTop;
          const footerOverlay = this.main.classList.contains('tptc-stack-footer-enabled');
          points = panels.map((node, index) => footerOverlay && index === panels.length - 1
            ? maximum : mainTop + index * height);
          if (!footerOverlay) points.push(mainTop + panels.length * height);
        } else {
          const hero = children.find((node) => node.querySelector('.hero, .tptc-image-slider, .tptc-hero-slider'));
          this.heroStart = hero ? this.topOf(hero) : -1;
          this.heroEnd = hero ? this.heroStart + hero.getBoundingClientRect().height : -1;
          points = children.map((node) => this.topOf(node));
          const footer = document.querySelector('.shopify-section-group-footer-group, #footer-group, footer');
          if (footer && !this.main.contains(footer)) points.push(this.topOf(footer));
        }
        points.push(0, maximum);
        this.positions = [...new Set(points.map((point) => Math.round(Math.min(maximum, Math.max(0, point)))))].sort((a, b) => a - b);
        this.update();
      }
      next(direction) {
        const top = this.scroller.scrollTop;
        if (!this.isHome) return direction < 0 && top > 3 ? 0 : undefined;
        return direction > 0 ? this.positions.find((point) => point > top + 3) : this.positions.findLast((point) => point < top - 3);
      }
      isLightBehind(button) {
        if (!document.elementsFromPoint) return !this.isHome;
        const rect = button.getBoundingClientRect();
        const elements = document.elementsFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
        for (const element of elements) {
          if (this.contains(element)) continue;
          const style = getComputedStyle(element);
          if (element.matches('img, video, canvas, iframe') || style.backgroundImage !== 'none') return !this.isHome;
          const value = style.backgroundColor;
          if (!value || value === 'transparent') continue;
          const numbers = value.match(/[\d.]+/g)?.map(Number);
          if (!numbers || numbers.length < 3) continue;
          if (numbers.length > 3 && numbers[3] < 0.5) continue;
          const divisor = value.startsWith('color(') ? 1 : 255;
          const brightness = (numbers[0] * 0.2126 + numbers[1] * 0.7152 + numbers[2] * 0.0722) / divisor;
          return brightness > 0.72;
        }
        return !this.isHome;
      }
      updateContrast() {
        const states = this.buttons.map((button) => this.isLightBehind(button));
        this.buttons.forEach((button, index) => button.classList.toggle('is-on-light', states[index]));
      }
      update() {
        if (!this.scroller) return;
        const top = this.scroller.scrollTop;
        const onHero = this.isHome && this.heroEnd > 0 && top >= this.heroStart - 3 && top < this.heroEnd - 3;
        const atTop = !this.isHome && top <= 3;
        this.classList.toggle('is-on-hero', onHero);
        this.classList.toggle('is-at-top', atTop);
        this.toggleAttribute('inert', onHero || atTop);
        this.buttons.forEach((button) => { button.disabled = this.next(Number(button.dataset.direction)) === undefined; });
        if (!onHero && !atTop) this.updateContrast();
      }
      stop() {
        if (!this.animation) return;
        cancelAnimationFrame(this.animation);
        this.animation = 0;
        this.scroller.style.scrollBehavior = this.oldBehavior;
        this.update();
      }
      go(target) {
        if (document.documentElement.hasAttribute('scroll-lock')) return;
        const start = this.scroller.scrollTop;
        const distance = target - start;
        this.oldBehavior = this.scroller.style.scrollBehavior;
        this.scroller.style.scrollBehavior = 'auto';
        if (this.reduced.matches) {
          this.scroller.scrollTop = target;
          this.scroller.style.scrollBehavior = this.oldBehavior;
          this.update();
          return;
        }
        const started = performance.now();
        const step = (now) => {
          const progress = Math.min((now - started) / 600, 1);
          const eased = progress < .5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
          this.scroller.scrollTop = start + distance * eased;
          if (progress < 1) this.animation = requestAnimationFrame(step);
          else {
            this.scroller.scrollTop = target;
            this.scroller.style.scrollBehavior = this.oldBehavior;
            this.animation = 0;
            this.update();
          }
        };
        this.animation = requestAnimationFrame(step);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tptc-collection-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tptc-collection-video-grid')) {
    customElements.define('tptc-collection-video-grid', class extends HTMLElement {
      connectedCallback() {
        this.videos = [...this.querySelectorAll('.tptc-collection-media__video')];
        if (!this.videos.length) return;
        this.section = this.closest('.shopify-section');
        this.main = this.closest('main');
        this.inView = false;
        this.enabled = false;
        this.pending = new WeakSet();
        this.frame = 0;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.refresh = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.updatePlayback();
          });
        };
        this.showPoster = video => video.parentElement.classList.remove('is-video-playing');
        this.onPlay = event => {
          const video = event.target;
          if (!this.videos.includes(video)) return;
          if (!this.shouldPlay()) {
            video.pause();
            this.showPoster(video);
          }
        };
        this.addEventListener('play', this.onPlay, { capture: true, ...options });
        for (const video of this.videos) {
          video.autoplay = false;
          video.removeAttribute('autoplay');
          video.muted = true;
          video.playsInline = true;
          video.preload = 'none';
          video.addEventListener('playing', () => {
            if (this.shouldPlay()) video.parentElement.classList.add('is-video-playing');
            else {
              video.pause();
              this.showPoster(video);
            }
          }, options);
          for (const name of ['pause', 'waiting', 'error', 'emptied']) {
            video.addEventListener(name, () => this.showPoster(video), options);
          }
        }
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
          this.updatePlayback();
        }, { threshold: [0, 0.5, 1] });
        this.observer.observe(this);
        this.mutationObserver = new MutationObserver(this.refresh);
        if (this.section) this.mutationObserver.observe(this.section, { attributes: true, attributeFilter: ['inert', 'class'] });
        if (this.main) this.mutationObserver.observe(this.main, { attributes: true, attributeFilter: ['class'] });
        document.addEventListener('scroll', this.refresh, { capture: true, passive: true, ...options });
        document.addEventListener('visibilitychange', this.refresh, options);
        window.addEventListener('resize', this.refresh, { passive: true, ...options });
        window.addEventListener('pagehide', () => this.pauseVideos(), options);
        window.addEventListener('pageshow', this.refresh, options);
      }
      shouldPlay() {
        if (!this.isConnected || document.hidden || !this.inView || this.section?.hasAttribute('inert')) return false;
        if (!this.main?.classList.contains('tptc-fabric-stack')) return true;
        const panels = [...this.main.children].filter(element => element.classList.contains('tptc-stack-panel'));
        const index = panels.indexOf(this.section);
        const height = parseFloat(getComputedStyle(this.main).getPropertyValue('--tptc-panel-height'));
        if (index < 0 || !Number.isFinite(height) || height <= 0) return true;
        let containerTop = 0;
        for (let parent = this.main.parentElement; parent && parent !== document.body && parent !== document.documentElement; parent = parent.parentElement) {
          if (/(auto|scroll)/.test(getComputedStyle(parent).overflowY) && parent.scrollHeight > parent.clientHeight + 1) {
            containerTop = parent.getBoundingClientRect().top + parent.clientTop;
            break;
          }
        }
        const local = containerTop - this.main.getBoundingClientRect().top;
        return Math.round(local / height) === index;
      }
      pauseVideos() {
        this.enabled = false;
        for (const video of this.videos) {
          video.pause();
          this.showPoster(video);
        }
      }
      updatePlayback() {
        const active = this.shouldPlay();
        if (!active) {
          this.pauseVideos();
          return;
        }
        this.enabled = true;
        for (const video of this.videos) {
          if (!video.paused || this.pending.has(video)) continue;
          video.preload = 'auto';
          this.pending.add(video);
          const attempt = video.play();
          Promise.resolve(attempt).then(() => {
            if (!this.shouldPlay()) {
              video.pause();
              this.showPoster(video);
            }
          }).catch(() => this.showPoster(video)).finally(() => this.pending.delete(video));
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.mutationObserver?.disconnect();
        this.abort?.abort();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.videos) this.pauseVideos();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tptc-contact-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const countries = [{"iso":"AF","name":"Afghanistan","code":"93","prefix":"0","lengths":[9],"primary":true},{"iso":"AX","name":"Åland Islands","code":"358","prefix":"0","lengths":[5,6,7,8,9,10,11,12],"primary":false},{"iso":"AL","name":"Albania","code":"355","prefix":"0","lengths":[6,7,8,9],"primary":true},{"iso":"DZ","name":"Algeria","code":"213","prefix":"0","lengths":[8,9],"primary":true},{"iso":"AS","name":"American Samoa","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"AD","name":"Andorra","code":"376","prefix":"","lengths":[6,8,9],"primary":true},{"iso":"AO","name":"Angola","code":"244","prefix":"","lengths":[9],"primary":true},{"iso":"AI","name":"Anguilla","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"AG","name":"Antigua and Barbuda","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"AR","name":"Argentina","code":"54","prefix":"0","lengths":[10,11],"primary":true},{"iso":"AM","name":"Armenia","code":"374","prefix":"0","lengths":[8],"primary":true},{"iso":"AW","name":"Aruba","code":"297","prefix":"","lengths":[7],"primary":true},{"iso":"AU","name":"Australia","code":"61","prefix":"0","lengths":[5,6,7,8,9,10,12],"primary":true},{"iso":"AT","name":"Austria","code":"43","prefix":"0","lengths":[4,5,6,7,8,9,10,11,12,13],"primary":true},{"iso":"AZ","name":"Azerbaijan","code":"994","prefix":"0","lengths":[9],"primary":true},{"iso":"BS","name":"Bahamas","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"BH","name":"Bahrain","code":"973","prefix":"","lengths":[8],"primary":true},{"iso":"BD","name":"Bangladesh","code":"880","prefix":"0","lengths":[6,7,8,9,10],"primary":true},{"iso":"BB","name":"Barbados","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"BY","name":"Belarus","code":"375","prefix":"8","lengths":[6,7,8,9,10,11],"primary":true},{"iso":"BE","name":"Belgium","code":"32","prefix":"0","lengths":[8,9],"primary":true},{"iso":"BZ","name":"Belize","code":"501","prefix":"","lengths":[7,11],"primary":true},{"iso":"BJ","name":"Benin","code":"229","prefix":"","lengths":[8,10],"primary":true},{"iso":"BM","name":"Bermuda","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"BT","name":"Bhutan","code":"975","prefix":"","lengths":[7,8],"primary":true},{"iso":"BO","name":"Bolivia","code":"591","prefix":"0","lengths":[8,9],"primary":true},{"iso":"BQ","name":"Bonaire, Sint Eustatius and Saba","code":"599","prefix":"","lengths":[7],"primary":false},{"iso":"BA","name":"Bosnia and Herzegovina","code":"387","prefix":"0","lengths":[8,9],"primary":true},{"iso":"BW","name":"Botswana","code":"267","prefix":"","lengths":[7,8,10],"primary":true},{"iso":"BR","name":"Brazil","code":"55","prefix":"0","lengths":[8,9,10,11],"primary":true},{"iso":"IO","name":"British Indian Ocean Territory","code":"246","prefix":"","lengths":[7],"primary":true},{"iso":"VG","name":"British Virgin Islands","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"BN","name":"Brunei","code":"673","prefix":"","lengths":[7],"primary":true},{"iso":"BG","name":"Bulgaria","code":"359","prefix":"0","lengths":[6,7,8,9,12],"primary":true},{"iso":"BF","name":"Burkina Faso","code":"226","prefix":"","lengths":[8],"primary":true},{"iso":"BI","name":"Burundi","code":"257","prefix":"","lengths":[8],"primary":true},{"iso":"KH","name":"Cambodia","code":"855","prefix":"0","lengths":[8,9,10],"primary":true},{"iso":"CM","name":"Cameroon","code":"237","prefix":"","lengths":[8,9],"primary":true},{"iso":"CA","name":"Canada","code":"1","prefix":"1","lengths":[7,10],"primary":false},{"iso":"CV","name":"Cape Verde","code":"238","prefix":"","lengths":[7],"primary":true},{"iso":"KY","name":"Cayman Islands","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"CF","name":"Central African Republic","code":"236","prefix":"","lengths":[8],"primary":true},{"iso":"TD","name":"Chad","code":"235","prefix":"","lengths":[8],"primary":true},{"iso":"CL","name":"Chile","code":"56","prefix":"","lengths":[9,10,11],"primary":true},{"iso":"CN","name":"China","code":"86","prefix":"0","lengths":[7,8,9,10,11,12],"primary":true},{"iso":"CX","name":"Christmas Island","code":"61","prefix":"0","lengths":[6,7,8,9,10,12],"primary":false},{"iso":"CC","name":"Cocos Islands","code":"61","prefix":"0","lengths":[6,7,8,9,10,12],"primary":false},{"iso":"CO","name":"Colombia","code":"57","prefix":"0","lengths":[8,10,11],"primary":true},{"iso":"KM","name":"Comoros","code":"269","prefix":"","lengths":[7],"primary":true},{"iso":"CG","name":"Congo","code":"242","prefix":"","lengths":[9],"primary":true},{"iso":"CK","name":"Cook Islands","code":"682","prefix":"","lengths":[5],"primary":true},{"iso":"CR","name":"Costa Rica","code":"506","prefix":"","lengths":[8,10],"primary":true},{"iso":"CI","name":"Côte d'Ivoire","code":"225","prefix":"","lengths":[10],"primary":true},{"iso":"HR","name":"Croatia","code":"385","prefix":"0","lengths":[7,8,9],"primary":true},{"iso":"CU","name":"Cuba","code":"53","prefix":"0","lengths":[6,7,8,10],"primary":true},{"iso":"CW","name":"Curaçao","code":"599","prefix":"","lengths":[7,8],"primary":true},{"iso":"CY","name":"Cyprus","code":"357","prefix":"","lengths":[8],"primary":true},{"iso":"CZ","name":"Czech Republic","code":"420","prefix":"","lengths":[9,10,11,12],"primary":true},{"iso":"DK","name":"Denmark","code":"45","prefix":"","lengths":[8],"primary":true},{"iso":"DJ","name":"Djibouti","code":"253","prefix":"","lengths":[8],"primary":true},{"iso":"DM","name":"Dominica","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"DO","name":"Dominican Republic","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"EC","name":"Ecuador","code":"593","prefix":"0","lengths":[8,9,10,11],"primary":true},{"iso":"EG","name":"Egypt","code":"20","prefix":"0","lengths":[8,9,10],"primary":true},{"iso":"SV","name":"El Salvador","code":"503","prefix":"","lengths":[7,8,11],"primary":true},{"iso":"GQ","name":"Equatorial Guinea","code":"240","prefix":"","lengths":[9],"primary":true},{"iso":"ER","name":"Eritrea","code":"291","prefix":"0","lengths":[7],"primary":true},{"iso":"EE","name":"Estonia","code":"372","prefix":"","lengths":[7,8,10],"primary":true},{"iso":"ET","name":"Ethiopia","code":"251","prefix":"0","lengths":[9],"primary":true},{"iso":"FK","name":"Falkland Islands","code":"500","prefix":"","lengths":[5],"primary":true},{"iso":"FO","name":"Faroe Islands","code":"298","prefix":"","lengths":[6],"primary":true},{"iso":"FJ","name":"Fiji","code":"679","prefix":"","lengths":[7,11],"primary":true},{"iso":"FI","name":"Finland","code":"358","prefix":"0","lengths":[5,6,7,8,9,10,11,12],"primary":true},{"iso":"FR","name":"France","code":"33","prefix":"0","lengths":[9],"primary":true},{"iso":"GF","name":"French Guiana","code":"594","prefix":"0","lengths":[9],"primary":true},{"iso":"PF","name":"French Polynesia","code":"689","prefix":"","lengths":[6,8,9],"primary":true},{"iso":"GA","name":"Gabon","code":"241","prefix":"","lengths":[7,8],"primary":true},{"iso":"GM","name":"Gambia","code":"220","prefix":"","lengths":[7,9],"primary":true},{"iso":"GE","name":"Georgia","code":"995","prefix":"0","lengths":[9],"primary":true},{"iso":"DE","name":"Germany","code":"49","prefix":"0","lengths":[4,5,6,7,8,9,10,11,12,13,14,15],"primary":true},{"iso":"GH","name":"Ghana","code":"233","prefix":"0","lengths":[8,9],"primary":true},{"iso":"GI","name":"Gibraltar","code":"350","prefix":"","lengths":[8],"primary":true},{"iso":"GR","name":"Greece","code":"30","prefix":"","lengths":[10,11,12],"primary":true},{"iso":"GL","name":"Greenland","code":"299","prefix":"","lengths":[6],"primary":true},{"iso":"GD","name":"Grenada","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"GP","name":"Guadeloupe","code":"590","prefix":"0","lengths":[9],"primary":true},{"iso":"GU","name":"Guam","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"GT","name":"Guatemala","code":"502","prefix":"","lengths":[8,11],"primary":true},{"iso":"GG","name":"Guernsey","code":"44","prefix":"0","lengths":[7,9,10],"primary":false},{"iso":"GN","name":"Guinea","code":"224","prefix":"","lengths":[8,9],"primary":true},{"iso":"GW","name":"Guinea-Bissau","code":"245","prefix":"","lengths":[7,9],"primary":true},{"iso":"GY","name":"Guyana","code":"592","prefix":"","lengths":[7],"primary":true},{"iso":"HT","name":"Haiti","code":"509","prefix":"","lengths":[8],"primary":true},{"iso":"HN","name":"Honduras","code":"504","prefix":"","lengths":[8,11],"primary":true},{"iso":"HK","name":"Hong Kong","code":"852","prefix":"","lengths":[5,6,7,8,9,11],"primary":true},{"iso":"HU","name":"Hungary","code":"36","prefix":"06","lengths":[8,9],"primary":true},{"iso":"IS","name":"Iceland","code":"354","prefix":"","lengths":[7,9],"primary":true},{"iso":"IN","name":"India","code":"91","prefix":"0","lengths":[8,9,10,11,12,13],"primary":true},{"iso":"ID","name":"Indonesia","code":"62","prefix":"0","lengths":[7,8,9,10,11,12,13,14,15,16,17],"primary":true},{"iso":"IR","name":"Iran","code":"98","prefix":"0","lengths":[4,5,6,7,10],"primary":true},{"iso":"IQ","name":"Iraq","code":"964","prefix":"0","lengths":[8,9,10],"primary":true},{"iso":"IE","name":"Ireland","code":"353","prefix":"0","lengths":[7,8,9,10],"primary":true},{"iso":"IM","name":"Isle Of Man","code":"44","prefix":"0","lengths":[10],"primary":false},{"iso":"IL","name":"Israel","code":"972","prefix":"0","lengths":[7,8,9,10,11,12],"primary":true},{"iso":"IT","name":"Italy","code":"39","prefix":"","lengths":[6,7,8,9,10,11,12],"primary":true},{"iso":"JM","name":"Jamaica","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"JP","name":"Japan","code":"81","prefix":"0","lengths":[8,9,10,11,12,13,14,15,16,17],"primary":true},{"iso":"JE","name":"Jersey","code":"44","prefix":"0","lengths":[10],"primary":false},{"iso":"JO","name":"Jordan","code":"962","prefix":"0","lengths":[8,9],"primary":true},{"iso":"KZ","name":"Kazakhstan","code":"7","prefix":"8","lengths":[10,14],"primary":false},{"iso":"KE","name":"Kenya","code":"254","prefix":"0","lengths":[7,8,9,10],"primary":true},{"iso":"KI","name":"Kiribati","code":"686","prefix":"0","lengths":[5,8],"primary":true},{"iso":"XK","name":"Kosovo","code":"383","prefix":"0","lengths":[8,9,10,11,12],"primary":true},{"iso":"KW","name":"Kuwait","code":"965","prefix":"","lengths":[7,8],"primary":true},{"iso":"KG","name":"Kyrgyzstan","code":"996","prefix":"0","lengths":[9,10],"primary":true},{"iso":"LA","name":"Laos","code":"856","prefix":"0","lengths":[8,9,10],"primary":true},{"iso":"LV","name":"Latvia","code":"371","prefix":"","lengths":[8],"primary":true},{"iso":"LB","name":"Lebanon","code":"961","prefix":"0","lengths":[7,8],"primary":true},{"iso":"LS","name":"Lesotho","code":"266","prefix":"","lengths":[8],"primary":true},{"iso":"LR","name":"Liberia","code":"231","prefix":"0","lengths":[7,8,9],"primary":true},{"iso":"LY","name":"Libya","code":"218","prefix":"0","lengths":[9],"primary":true},{"iso":"LI","name":"Liechtenstein","code":"423","prefix":"0","lengths":[7,9],"primary":true},{"iso":"LT","name":"Lithuania","code":"370","prefix":"0","lengths":[8],"primary":true},{"iso":"LU","name":"Luxembourg","code":"352","prefix":"","lengths":[4,5,6,7,8,9,10,11],"primary":true},{"iso":"MO","name":"Macao","code":"853","prefix":"","lengths":[7,8],"primary":true},{"iso":"MK","name":"Macedonia","code":"389","prefix":"0","lengths":[8],"primary":true},{"iso":"MG","name":"Madagascar","code":"261","prefix":"0","lengths":[9],"primary":true},{"iso":"MW","name":"Malawi","code":"265","prefix":"0","lengths":[7,9],"primary":true},{"iso":"MY","name":"Malaysia","code":"60","prefix":"0","lengths":[8,9,10],"primary":true},{"iso":"MV","name":"Maldives","code":"960","prefix":"","lengths":[7,10],"primary":true},{"iso":"ML","name":"Mali","code":"223","prefix":"","lengths":[8],"primary":true},{"iso":"MT","name":"Malta","code":"356","prefix":"","lengths":[8],"primary":true},{"iso":"MH","name":"Marshall Islands","code":"692","prefix":"1","lengths":[7],"primary":true},{"iso":"MQ","name":"Martinique","code":"596","prefix":"0","lengths":[9],"primary":true},{"iso":"MR","name":"Mauritania","code":"222","prefix":"","lengths":[8],"primary":true},{"iso":"MU","name":"Mauritius","code":"230","prefix":"","lengths":[7,8,10],"primary":true},{"iso":"YT","name":"Mayotte","code":"262","prefix":"0","lengths":[9],"primary":false},{"iso":"MX","name":"Mexico","code":"52","prefix":"","lengths":[10],"primary":true},{"iso":"FM","name":"Micronesia","code":"691","prefix":"","lengths":[7],"primary":true},{"iso":"MD","name":"Moldova","code":"373","prefix":"0","lengths":[8],"primary":true},{"iso":"MC","name":"Monaco","code":"377","prefix":"0","lengths":[8,9],"primary":true},{"iso":"MN","name":"Mongolia","code":"976","prefix":"0","lengths":[8,9,10],"primary":true},{"iso":"ME","name":"Montenegro","code":"382","prefix":"0","lengths":[8,9],"primary":true},{"iso":"MS","name":"Montserrat","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"MA","name":"Morocco","code":"212","prefix":"0","lengths":[9],"primary":true},{"iso":"MZ","name":"Mozambique","code":"258","prefix":"","lengths":[8,9],"primary":true},{"iso":"MM","name":"Myanmar","code":"95","prefix":"0","lengths":[6,7,8,9,10],"primary":true},{"iso":"NA","name":"Namibia","code":"264","prefix":"0","lengths":[8,9],"primary":true},{"iso":"NR","name":"Nauru","code":"674","prefix":"","lengths":[7],"primary":true},{"iso":"NP","name":"Nepal","code":"977","prefix":"0","lengths":[8,10,11],"primary":true},{"iso":"NL","name":"Netherlands","code":"31","prefix":"0","lengths":[5,6,7,8,9,10,11],"primary":true},{"iso":"NC","name":"New Caledonia","code":"687","prefix":"","lengths":[6],"primary":true},{"iso":"NZ","name":"New Zealand","code":"64","prefix":"0","lengths":[5,6,7,8,9,10],"primary":true},{"iso":"NI","name":"Nicaragua","code":"505","prefix":"","lengths":[8],"primary":true},{"iso":"NE","name":"Niger","code":"227","prefix":"","lengths":[8],"primary":true},{"iso":"NG","name":"Nigeria","code":"234","prefix":"0","lengths":[10,11,12,13,14],"primary":true},{"iso":"NU","name":"Niue","code":"683","prefix":"","lengths":[4,7],"primary":true},{"iso":"NF","name":"Norfolk Island","code":"672","prefix":"","lengths":[6],"primary":true},{"iso":"KP","name":"North Korea","code":"850","prefix":"0","lengths":[8,10],"primary":true},{"iso":"MP","name":"Northern Mariana Islands","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"NO","name":"Norway","code":"47","prefix":"","lengths":[5,8],"primary":true},{"iso":"OM","name":"Oman","code":"968","prefix":"","lengths":[7,8,9],"primary":true},{"iso":"PK","name":"Pakistan","code":"92","prefix":"0","lengths":[8,9,10,11,12],"primary":true},{"iso":"PW","name":"Palau","code":"680","prefix":"","lengths":[7],"primary":true},{"iso":"PS","name":"Palestine","code":"970","prefix":"0","lengths":[8,9,10],"primary":true},{"iso":"PA","name":"Panama","code":"507","prefix":"","lengths":[7,8,10,11],"primary":true},{"iso":"PG","name":"Papua New Guinea","code":"675","prefix":"","lengths":[7,8],"primary":true},{"iso":"PY","name":"Paraguay","code":"595","prefix":"0","lengths":[6,7,8,9,10,11],"primary":true},{"iso":"PE","name":"Peru","code":"51","prefix":"0","lengths":[8,9],"primary":true},{"iso":"PH","name":"Philippines","code":"63","prefix":"0","lengths":[6,8,9,10,11,12,13],"primary":true},{"iso":"PL","name":"Poland","code":"48","prefix":"","lengths":[6,7,8,9,10],"primary":true},{"iso":"PT","name":"Portugal","code":"351","prefix":"","lengths":[9],"primary":true},{"iso":"PR","name":"Puerto Rico","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"QA","name":"Qatar","code":"974","prefix":"","lengths":[7,8,9,11],"primary":true},{"iso":"RE","name":"Reunion","code":"262","prefix":"0","lengths":[9],"primary":true},{"iso":"RO","name":"Romania","code":"40","prefix":"0","lengths":[6,9],"primary":true},{"iso":"RU","name":"Russia","code":"7","prefix":"8","lengths":[10,14],"primary":true},{"iso":"RW","name":"Rwanda","code":"250","prefix":"0","lengths":[8,9],"primary":true},{"iso":"SH","name":"Saint Helena","code":"290","prefix":"","lengths":[4,5],"primary":true},{"iso":"KN","name":"Saint Kitts And Nevis","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"LC","name":"Saint Lucia","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"PM","name":"Saint Pierre And Miquelon","code":"508","prefix":"0","lengths":[6,9],"primary":true},{"iso":"VC","name":"Saint Vincent And The Grenadines","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"WS","name":"Samoa","code":"685","prefix":"","lengths":[5,6,7,10],"primary":true},{"iso":"SM","name":"San Marino","code":"378","prefix":"","lengths":[8,10],"primary":true},{"iso":"ST","name":"Sao Tome And Principe","code":"239","prefix":"","lengths":[7],"primary":true},{"iso":"SA","name":"Saudi Arabia","code":"966","prefix":"0","lengths":[9,10],"primary":true},{"iso":"SN","name":"Senegal","code":"221","prefix":"","lengths":[9],"primary":true},{"iso":"RS","name":"Serbia","code":"381","prefix":"0","lengths":[6,7,8,9,10,11,12],"primary":true},{"iso":"SC","name":"Seychelles","code":"248","prefix":"","lengths":[7],"primary":true},{"iso":"SL","name":"Sierra Leone","code":"232","prefix":"0","lengths":[8],"primary":true},{"iso":"SG","name":"Singapore","code":"65","prefix":"","lengths":[8,10,11],"primary":true},{"iso":"SX","name":"Sint Maarten (Dutch part)","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"SK","name":"Slovakia","code":"421","prefix":"0","lengths":[6,7,9],"primary":true},{"iso":"SI","name":"Slovenia","code":"386","prefix":"0","lengths":[5,6,7,8],"primary":true},{"iso":"SB","name":"Solomon Islands","code":"677","prefix":"","lengths":[5,7],"primary":true},{"iso":"SO","name":"Somalia","code":"252","prefix":"0","lengths":[6,7,8,9],"primary":true},{"iso":"ZA","name":"South Africa","code":"27","prefix":"0","lengths":[5,6,7,8,9,10],"primary":true},{"iso":"KR","name":"South Korea","code":"82","prefix":"0","lengths":[5,6,8,9,10,11,12,13,14],"primary":true},{"iso":"SS","name":"South Sudan","code":"211","prefix":"0","lengths":[9],"primary":true},{"iso":"ES","name":"Spain","code":"34","prefix":"","lengths":[9],"primary":true},{"iso":"LK","name":"Sri Lanka","code":"94","prefix":"0","lengths":[9],"primary":true},{"iso":"BL","name":"St. Barthélemy","code":"590","prefix":"0","lengths":[9],"primary":false},{"iso":"MF","name":"St. Martin","code":"590","prefix":"0","lengths":[9],"primary":false},{"iso":"SD","name":"Sudan","code":"249","prefix":"0","lengths":[9],"primary":true},{"iso":"SR","name":"Suriname","code":"597","prefix":"","lengths":[6,7],"primary":true},{"iso":"SJ","name":"Svalbard And Jan Mayen","code":"47","prefix":"","lengths":[5,8],"primary":false},{"iso":"SZ","name":"Swaziland","code":"268","prefix":"","lengths":[8,9],"primary":true},{"iso":"SE","name":"Sweden","code":"46","prefix":"0","lengths":[6,7,8,9,10,12],"primary":true},{"iso":"CH","name":"Switzerland","code":"41","prefix":"0","lengths":[9,12],"primary":true},{"iso":"SY","name":"Syria","code":"963","prefix":"0","lengths":[8,9],"primary":true},{"iso":"TW","name":"Taiwan","code":"886","prefix":"0","lengths":[7,8,9,10,11],"primary":true},{"iso":"TJ","name":"Tajikistan","code":"992","prefix":"","lengths":[9],"primary":true},{"iso":"TZ","name":"Tanzania","code":"255","prefix":"0","lengths":[9],"primary":true},{"iso":"TH","name":"Thailand","code":"66","prefix":"0","lengths":[8,9,10,13],"primary":true},{"iso":"CD","name":"The Democratic Republic Of Congo","code":"243","prefix":"0","lengths":[7,8,9,10],"primary":true},{"iso":"TL","name":"Timor-Leste","code":"670","prefix":"","lengths":[7,8],"primary":true},{"iso":"TG","name":"Togo","code":"228","prefix":"","lengths":[8],"primary":true},{"iso":"TK","name":"Tokelau","code":"690","prefix":"","lengths":[4,5,6,7],"primary":true},{"iso":"TO","name":"Tonga","code":"676","prefix":"","lengths":[5,7],"primary":true},{"iso":"TT","name":"Trinidad and Tobago","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"TA","name":"Tristan da Cunha","code":"290","prefix":"","lengths":[4],"primary":false},{"iso":"TN","name":"Tunisia","code":"216","prefix":"","lengths":[8],"primary":true},{"iso":"TR","name":"Turkey","code":"90","prefix":"0","lengths":[7,10,12,13],"primary":true},{"iso":"TM","name":"Turkmenistan","code":"993","prefix":"8","lengths":[8],"primary":true},{"iso":"TC","name":"Turks And Caicos Islands","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"TV","name":"Tuvalu","code":"688","prefix":"","lengths":[5,6,7],"primary":true},{"iso":"VI","name":"U.S. Virgin Islands","code":"1","prefix":"1","lengths":[10],"primary":false},{"iso":"UG","name":"Uganda","code":"256","prefix":"0","lengths":[9],"primary":true},{"iso":"UA","name":"Ukraine","code":"380","prefix":"0","lengths":[9,10],"primary":true},{"iso":"AE","name":"United Arab Emirates","code":"971","prefix":"0","lengths":[5,6,7,8,9,10,11,12],"primary":true},{"iso":"GB","name":"United Kingdom","code":"44","prefix":"0","lengths":[7,9,10],"primary":true},{"iso":"US","name":"United States","code":"1","prefix":"1","lengths":[10],"primary":true},{"iso":"UY","name":"Uruguay","code":"598","prefix":"0","lengths":[4,5,6,7,8,9,10,11,12,13],"primary":true},{"iso":"UZ","name":"Uzbekistan","code":"998","prefix":"","lengths":[9],"primary":true},{"iso":"VU","name":"Vanuatu","code":"678","prefix":"","lengths":[5,7],"primary":true},{"iso":"VA","name":"Vatican","code":"39","prefix":"","lengths":[6,7,8,9,10,11,12],"primary":false},{"iso":"VE","name":"Venezuela","code":"58","prefix":"0","lengths":[10],"primary":true},{"iso":"VN","name":"Vietnam","code":"84","prefix":"0","lengths":[7,8,9,10],"primary":true},{"iso":"WF","name":"Wallis And Futuna","code":"681","prefix":"","lengths":[6,9],"primary":true},{"iso":"EH","name":"Western Sahara","code":"212","prefix":"0","lengths":[9],"primary":false},{"iso":"YE","name":"Yemen","code":"967","prefix":"0","lengths":[7,8,9],"primary":true},{"iso":"ZM","name":"Zambia","code":"260","prefix":"0","lengths":[9],"primary":true},{"iso":"ZW","name":"Zimbabwe","code":"263","prefix":"0","lengths":[7,9,10],"primary":true}];
  const flagURL = iso => 'https://flagcdn.com/32x24/' + iso.toLowerCase() + '.png';
  const fold = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const init = (scope = document) => {
    scope.querySelectorAll('.tptc-contact__form input[name="contact[country]"]').forEach(field => {
      const select = document.createElement('select');
      select.id = field.id;
      select.name = field.name;
      select.autocomplete = 'country-name';
      select.className = field.className;
      select.required = field.required;
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select your country';
      select.append(placeholder);
      countries.forEach(country => {
        const option = document.createElement('option');
        option.value = country.name;
        option.textContent = country.name;
        option.selected = fold(field.value) === fold(country.name) || field.value.toUpperCase() === country.iso;
        select.append(option);
      });
      if (!field.value) select.value = '';
      field.replaceWith(select);
    });
    scope.querySelectorAll('[data-tptc-international-phone]').forEach(phone => {
      if (phone.dataset.selectorBound) return;
      const form = phone.form;
      if (!form) return;
      phone.dataset.selectorBound = 'true';
      
      let selected = countries.find(country => country.iso === 'US');
      let shown = [];
      let lastQuery = null;
      const originalValue = phone.value;
      const configuredLimit = Number(phone.dataset.maxDigits);
      const maxDigits = Number.isInteger(configuredLimit) && configuredLimit >= 6 && configuredLimit <= 15 ? configuredLimit : 15;
      const full = document.createElement('input');
      full.type = 'hidden';
      full.hidden = true;
      full.style.display = 'none';
      full.name = phone.name;
      phone.removeAttribute('name');
      phone.pattern = '[0-9]+';
      phone.autocomplete = 'tel-national';
      phone.inputMode = 'numeric';
      phone.placeholder = '3001234567';
      const row = document.createElement('div');
      row.className = 'tptc-phone-row';
      const picker = document.createElement('div');
      picker.className = 'tptc-phone-picker';
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'tptc-phone-trigger';
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
      const flag = document.createElement('img');
      flag.width = 24; flag.height = 18; flag.alt = '';
      flag.referrerPolicy = 'no-referrer';
      flag.addEventListener('error', () => { flag.hidden = true; });
      const selectedText = document.createElement('span');
      trigger.append(flag, selectedText);
      const panel = document.createElement('div');
      panel.className = 'tptc-phone-panel';
      panel.id = phone.id + '-country-panel';
      panel.hidden = true;
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-label', 'Choose phone country code');
      trigger.setAttribute('aria-controls', panel.id);
      const search = document.createElement('input');
      search.type = 'search'; search.placeholder = 'Search country or code';
      search.setAttribute('aria-label', 'Search country name or dialling code');
      search.autocomplete = 'off';
      const list = document.createElement('div');
      list.className = 'tptc-phone-options';
      list.id = phone.id + '-country-options';
      search.setAttribute('aria-controls', list.id);
      const status = document.createElement('p');
      status.className = 'tptc-phone-status';
      status.setAttribute('role', 'status');
      panel.append(search, list, status);
      picker.append(trigger, panel);
      Object.defineProperty(picker, 'open', {
        get() { return picker.hasAttribute('open'); },
        set(value) {
          const open = Boolean(value);
          if (picker.open === open) return;
          picker.toggleAttribute('open', open);
          panel.hidden = !open;
          picker.dispatchEvent(new Event('toggle'));
        }
      });
      trigger.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        picker.open = !picker.open;
      });
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') { event.preventDefault(); picker.open = true; search.focus(); }
        if (event.key === 'Escape') { event.preventDefault(); picker.open = false; }
      });
      panel.addEventListener('click', event => event.stopPropagation());
      phone.parentNode.insertBefore(row, phone);
      row.append(picker, phone, full);
      phone.classList.add('tptc-phone-national');

      function setCountry(country) {
        selected = country;
        flag.hidden = false;
        flag.src = flagURL(country.iso);
        selectedText.textContent = country.iso + ' +' + country.code;
        trigger.setAttribute('aria-label', 'Phone country: ' + country.name + ', +' + country.code);
        phone.placeholder = 'Phone number';
        phone.maxLength = maxDigits - country.code.length;
        phone.title = 'Numbers only. Maximum ' + phone.maxLength + ' digits in this field.';
      }
      function update() {
        phone.setCustomValidity('');
        phone.removeAttribute('aria-invalid');
        full.value = '';
        const raw = phone.value.trim();
        if (!raw) return;
        if (!/^[0-9]+$/.test(raw)) {
          phone.setCustomValidity('Enter digits only in the phone number field. Choose the country code from the dropdown.');
          return;
        }
        const value = '+' + selected.code + raw;
        if (raw.length > phone.maxLength) {
          phone.setCustomValidity('Enter a maximum of ' + phone.maxLength + ' digits for the selected country code.');
          return;
        }
        full.value = value;
      }
      function acceptInternational(value) {
        if (!value.trim().startsWith('+')) return false;
        const cleaned = value.replace(/[\s().-]/g, '');
        if (!/^\+[1-9][0-9]{1,14}$/.test(cleaned)) return false;
        const digits = cleaned.slice(1);
        const matches = countries.filter(country => digits.startsWith(country.code));
        matches.sort((a,b) => b.code.length - a.code.length || Number(b.iso === selected.iso) - Number(a.iso === selected.iso) || Number(b.primary) - Number(a.primary));
        if (!matches.length) return false;
        setCountry(matches[0]);
        phone.value = digits.slice(selected.code.length);
        return true;
      }
      function render() {
        const query = fold(search.value.trim());
        if (query === lastQuery) return;
        lastQuery = query;
        list.replaceChildren();
        shown = countries.filter(country => fold(country.name + ' ' + country.iso + ' +' + country.code).includes(query));
        const fragment = document.createDocumentFragment();
        shown.forEach(country => {
          const option = document.createElement('button');
          option.type = 'button';
          option.className = 'tptc-phone-option';
          option.dataset.iso = country.iso;
          option.setAttribute('aria-pressed', String(country.iso === selected.iso));
          const img = document.createElement('img');
          img.width = 24; img.height = 18; img.alt = ''; img.loading = 'lazy';
          img.referrerPolicy = 'no-referrer'; img.src = flagURL(country.iso);
          img.addEventListener('error', () => { img.hidden = true; });
          const name = document.createElement('span'); name.textContent = country.name;
          const code = document.createElement('span'); code.className = 'tptc-phone-code'; code.textContent = '+' + country.code;
          option.append(img, name, code);
          option.addEventListener('pointerdown', event => {
            if (event.pointerType === 'mouse') event.preventDefault();
          });
          option.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            setCountry(country);
            update();
            picker.open = false;
            phone.focus();
          });
          fragment.append(option);
        });
        list.append(fragment);
        status.textContent = shown.length ? '' : 'No countries found.';
      }
      const onOutside = event => {
        if (!picker.isConnected) {
          document.removeEventListener('pointerdown', onOutside);
          return;
        }
        if (!picker.contains(event.target)) picker.open = false;
      };
      picker.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(picker.open));
        if (picker.open) {
          search.value = ''; lastQuery = null; render(); search.focus();
          document.addEventListener('pointerdown', onOutside);
        } else document.removeEventListener('pointerdown', onOutside);
      });
      search.addEventListener('input', render);
      panel.addEventListener('keydown', event => {
        const options = Array.from(list.querySelectorAll('button'));
        const index = options.indexOf(document.activeElement);
        if (event.key === 'Escape') {
          event.preventDefault(); event.stopPropagation(); picker.open = false; trigger.focus();
        } else if (event.key === 'Enter' && event.target === search) {
          event.preventDefault(); options[0]?.click();
        } else if (event.key === 'ArrowDown') {
          event.preventDefault(); options[Math.min(index + 1, options.length - 1)]?.focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault(); if (index <= 0) search.focus(); else options[index - 1]?.focus();
        }
      });
      phone.addEventListener('beforeinput', event => {
        if (event.data && /[^0-9]/.test(event.data)) event.preventDefault();
      });
      phone.addEventListener('input', () => {
        const value = phone.value;
        const caret = phone.selectionStart;
        const clean = value.replace(/[^0-9]/g, '').slice(0, phone.maxLength);
        if (clean !== value) {
          phone.value = clean;
          if (caret !== null) {
            const position = Math.min(value.slice(0, caret).replace(/[^0-9]/g, '').length, clean.length);
            phone.setSelectionRange(position, position);
          }
        }
        update();
      });
      phone.addEventListener('paste', event => {
        const text = event.clipboardData?.getData('text');
        if (typeof text !== 'string') return;
        event.preventDefault();
        const start = phone.selectionStart ?? phone.value.length;
        const end = phone.selectionEnd ?? start;
        const digits = text.replace(/[^0-9]/g, '');
        const insert = digits.slice(0, Math.max(0, phone.maxLength - (phone.value.length - (end - start))));
        phone.value = phone.value.slice(0, start) + insert + phone.value.slice(end);
        phone.setSelectionRange(start + insert.length, start + insert.length);
        update();
      });
      phone.addEventListener('invalid', () => {
        if (phone.validity.valueMissing) phone.setCustomValidity('Please enter your phone number.');
        phone.setAttribute('aria-invalid','true');
      });
      form.addEventListener('submit', event => {
        update();
        if (!phone.checkValidity() || !full.value) { event.preventDefault(); phone.reportValidity(); }
      }, true);
      form.addEventListener('reset', () => queueMicrotask(() => {
        setCountry(countries.find(country => country.iso === 'US'));
        phone.value = ''; update();
      }));
      setCountry(selected);
      if (originalValue) acceptInternational(originalValue);
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('.tptc-contact[data-map-reveal="true"] [data-contact-map]').forEach((map) => {
        if (map.dataset.revealBound || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        map.dataset.revealBound = 'true';
        map.classList.add('is-pending');
        let ready = false;
        let visible = false;
        const image = map.querySelector('img');
        const start = () => {
          if (ready && visible && map.isConnected) {
            map.classList.add('is-revealing');
            observer.unobserve(map);
          }
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target !== map) return;
            visible = entry.isIntersecting;
            start();
          });
        }, { threshold: 0.12 });
        observer.observe(map);
        if (!image || image.complete) {
          ready = true;
          start();
        } else {
          image.addEventListener('load', () => { ready = true; start(); }, { once: true });
          image.addEventListener('error', () => { map.classList.remove('is-pending'); observer.disconnect(); }, { once: true });
        }
        const cleanup = (event) => {
          if (!event.target.contains(map)) return;
          observer.disconnect();
          document.removeEventListener('shopify:section:unload', cleanup);
        };
        document.addEventListener('shopify:section:unload', cleanup);
      });
    };
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tptc-hero-scroll-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tptc-scroll-hero')) {
    customElements.define('tptc-scroll-hero', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tptc-scroll-hero__track');
        this.slides = [...this.querySelectorAll('.tptc-scroll-hero__slide')];
        if (!this.track || !this.slides.length) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.index = 0;
        this.drag = null;
        this.blockClickUntil = 0;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.interacting = false;
        this.wrapping = false;
        this.wrapTimer = 0;
        if (this.slides.length > 1 && this.dataset.loop === 'true') {
          this.loopSlide = this.slides[0].cloneNode(true);
          this.loopSlide.removeAttribute('data-slide-index');
          this.loopSlide.setAttribute('data-loop-clone', '');
          this.loopSlide.setAttribute('aria-hidden', 'true');
          this.loopSlide.setAttribute('inert', '');
          [this.loopSlide, ...this.loopSlide.querySelectorAll('*')].forEach((node) => {
            node.removeAttribute('id');
            node.removeAttribute('data-shopify-editor-block');
          });
          this.loopSlide.querySelectorAll('img').forEach((image) => { image.loading = 'lazy'; image.fetchPriority = 'auto'; });
          this.track.append(this.loopSlide);
        }
        this.timer = 0;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.track.addEventListener('scroll', () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
        }, { passive: true, signal });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-next-section')) {
            event.preventDefault();
            event.stopPropagation();
            this.scrollNextSection();
            return;
          }
          if (button.hasAttribute('data-direction')) this.go(this.index + Number(button.dataset.direction));
          if (button.hasAttribute('data-go-to')) this.go(Number(button.dataset.goTo));
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          const direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (!direction) return;
          event.preventDefault();
          event.stopPropagation();
          this.go(this.index + direction);
        }, { signal });
        this.track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
        this.track.addEventListener('pointerdown', (event) => this.startDrag(event), { signal });
        window.addEventListener('pointermove', (event) => this.moveDrag(event), { passive: false, signal });
        window.addEventListener('pointerup', (event) => this.endDrag(event), { signal });
        window.addEventListener('pointercancel', (event) => this.endDrag(event, true), { signal });
        this.track.addEventListener('click', (event) => {
          if (performance.now() < this.blockClickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal });
        this.addEventListener('mouseenter', () => {
          this.hovered = this.dataset.pauseHover === 'true';
          this.queueAutoplay();
        }, { signal });
        this.addEventListener('mouseleave', () => {
          this.hovered = false;
          this.queueAutoplay();
        }, { signal });
        this.addEventListener('focusin', (event) => {
          this.focused = true;
          this.queueAutoplay();
        }, { signal });
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            this.focused = this.contains(document.activeElement);
            this.queueAutoplay();
          });
        }, { signal });
        this.track.addEventListener('pointerdown', () => {
          if (this.wrapping) this.go(this.index, true);
          this.interacting = true;
          this.queueAutoplay();
        }, { signal });
        const finishInteraction = () => {
          this.interacting = false;
          this.queueAutoplay();
        };
        window.addEventListener('pointerup', finishInteraction, { signal });
        window.addEventListener('pointercancel', finishInteraction, { signal });
        document.addEventListener('visibilitychange', () => this.queueAutoplay(), { signal });
        window.addEventListener('pagehide', () => clearTimeout(this.timer), { signal });
        window.addEventListener('pageshow', () => this.queueAutoplay(), { signal });
        this.visibility = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting && entry.intersectionRatio >= .25;
          this.queueAutoplay();
        }, { threshold: [0, .25] });
        this.visibility.observe(this);
        this.panel = this.closest('.shopify-section');
        this.panelObserver = new MutationObserver(() => this.queueAutoplay());
        if (this.panel) this.panelObserver.observe(this.panel, { attributes: true, attributeFilter: ['class', 'inert'] });
        this.reduced.addEventListener('change', () => this.queueAutoplay(), { signal });
        this.selectBlock = (event) => {
          if (!this.contains(event.target)) return;
          const slide = event.target.closest('.tptc-scroll-hero__slide');
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.go(index, true);
        };
        document.addEventListener('shopify:block:select', this.selectBlock, { signal });
        this.track.addEventListener('scrollend', () => this.finishLoop(), { signal });
        this.resize = new ResizeObserver(() => this.go(this.index, true));
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.wrapTimer);
        this.loopSlide?.remove();
        this.loopSlide = null;
        this.visibility?.disconnect();
        this.panelObserver?.disconnect();
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame || 0);
      }
      go(index, instant = false) {
        this.wrapping = false;
        clearTimeout(this.wrapTimer);
        index = Math.min(Math.max(index, 0), this.slides.length - 1);
        this.index = index;
        this.track.scrollTo({
          left: index * this.track.clientWidth,
          behavior: instant || this.reduced.matches ? 'instant' : 'smooth'
        });
        this.updateControls();
        this.queueAutoplay();
      }
      update() {
        if (this.wrapping) {
          clearTimeout(this.wrapTimer);
          this.wrapTimer = setTimeout(() => this.finishLoop(), 160);
          return;
        }
        if (this.loopSlide && this.track.scrollLeft >= this.slides.length * this.track.clientWidth - 2) {
          this.go(0, true);
          return;
        }
        this.index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1))));
        this.updateControls();
        this.queueAutoplay();
      }
      updateControls() {
        this.querySelectorAll('[data-direction]').forEach((button) => {
          button.disabled = Number(button.dataset.direction) < 0 ? this.index === 0 : this.index === this.slides.length - 1;
        });
        this.querySelectorAll('[data-go-to]').forEach((button) => {
          if (Number(button.dataset.goTo) === this.index) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        this.slides.forEach((slide, index) => {
          slide.querySelectorAll('a, button').forEach((element) => element.setAttribute('tabindex', index === this.index ? '0' : '-1'));
        });
      }
      canAutoplay() {
        return this.isConnected && this.dataset.autoplay === 'true' && this.slides.length > 1 &&
          this.visible && !document.hidden && !this.reduced.matches && !this.wrapping &&
          !this.hovered && !this.focused && !this.interacting && !this.drag &&
          !this.panel?.hasAttribute('inert') &&
          (!this.panel?.classList.contains('tptc-stack-panel') || this.panel.classList.contains('tptc-stack-panel--active'));
      }
      queueAutoplay() {
        clearTimeout(this.timer);
        this.timer = 0;
        if (!this.canAutoplay()) return;
        if (this.index === this.slides.length - 1 && this.dataset.loop !== 'true') return;
        const delay = Math.max(3000, Number(this.dataset.interval) || 5000);
        this.timer = setTimeout(() => {
          this.timer = 0;
          if (!this.canAutoplay()) return;
          const next = this.index + 1;
          if (next >= this.slides.length && this.loopSlide) this.startLoop();
          else this.go(next >= this.slides.length ? 0 : next);
        }, delay);
      }
      scrollNextSection() {
        const main = this.closest('#MainContent');
        const current = this.closest('.shopify-section');
        if (!main || !current) return;
        const sections = [...main.children].filter((element) =>
          element.classList.contains('shopify-section') &&
          element.getBoundingClientRect().height > 0 &&
          getComputedStyle(element).display !== 'none' &&
          !element.classList.contains('tptc-stack-skip')
        );
        const next = sections[sections.indexOf(current) + 1];
        if (!next) return;
        let container = document.scrollingElement || document.documentElement;
        for (let parent = main.parentElement; parent; parent = parent.parentElement) {
          if (/(auto|scroll)/.test(getComputedStyle(parent).overflowY) && parent.scrollHeight > parent.clientHeight + 1) {
            container = parent;
            break;
          }
        }
        const isDocument = container === document.scrollingElement || container === document.documentElement;
        const containerTop = isDocument ? 0 : container.getBoundingClientRect().top + container.clientTop;
        const panels = sections.filter((section) => section.classList.contains('tptc-stack-panel'));
        const nextIndex = panels.indexOf(next);
        let top = container.scrollTop + next.getBoundingClientRect().top - containerTop;
        if (main.classList.contains('tptc-fabric-stack') && nextIndex >= 0 && !this.reduced.matches) {
          const height = parseFloat(getComputedStyle(main).getPropertyValue('--tptc-panel-height'));
          if (Number.isFinite(height) && height > 0) top = container.scrollTop + main.getBoundingClientRect().top - containerTop + nextIndex * height;
        }
        container.scrollTo({ top: Math.max(0, top), behavior: this.reduced.matches ? 'instant' : 'smooth' });
      }
      startLoop() {
        clearTimeout(this.timer);
        this.wrapping = true;
        this.track.scrollTo({
          left: this.slides.length * this.track.clientWidth,
          behavior: 'smooth'
        });
        clearTimeout(this.wrapTimer);
        this.wrapTimer = setTimeout(() => this.finishLoop(), 1000);
      }
      finishLoop() {
        if (!this.wrapping) return;
        const target = this.slides.length * this.track.clientWidth;
        if (Math.abs(this.track.scrollLeft - target) > 2) return;
        this.go(0, true);
      }
      startDrag(event) {
        if (event.target.closest('.tptc-scroll-hero__controls')) return;
        if (this.wrapping) this.go(this.index, true);
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.slides.length < 2) return;
        this.drag = {
          id: event.pointerId,
          x: event.clientX,
          left: this.track.scrollLeft,
          index: this.index,
          moved: false
        };
      }
      moveDrag(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const distance = event.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(distance) < 6) return;
        if (!this.drag.moved) {
          this.drag.moved = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        if (event.cancelable) event.preventDefault();
        this.track.scrollLeft = this.drag.left - distance;
      }
      endDrag(event, cancelled = false) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const drag = this.drag;
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        if (!drag.moved) return;
        this.blockClickUntil = performance.now() + 350;
        const distance = event.clientX - drag.x;
        const threshold = Math.min(80, this.track.clientWidth * .15);
        const target = !cancelled && Math.abs(distance) > threshold
          ? drag.index + (distance < 0 ? 1 : -1)
          : Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
        this.go(target);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tptc-news-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tptc-news-ticker')) {
    customElements.define('tptc-news-ticker', class extends HTMLElement {
      connectedCallback() {
        this.originalHeaders = new Map();
        this.updateHeight = () => {
          if (!this.isConnected) return;
          const height = this.getBoundingClientRect().height;
          const headerHeight = this.header?.getBoundingClientRect().height || 0;
          if (height > 0) {
            document.documentElement.style.setProperty('--tptc-news-ticker-height', `${height}px`);
            document.documentElement.style.setProperty('--tptc-header-stack-height', `${height + headerHeight}px`);
            if (height !== this.lastHeight) {
              this.lastHeight = height;
              window.dispatchEvent(new CustomEvent('tptc:ticker-resize'));
            }
          }
        };
        this.heightObserver = new ResizeObserver(this.updateHeight);
        this.heightObserver.observe(this);
        this.bindHeader = () => {
          const header = document.querySelector('#header-component');
          if (!header || header === this.header) return;
          if (this.header) this.heightObserver.unobserve(this.header);
          this.header = header;
          if (!this.originalHeaders.has(header)) {
            this.originalHeaders.set(header, {
              sticky: header.getAttribute('sticky'),
              transparent: header.getAttribute('transparent'),
              'data-sticky-state': header.getAttribute('data-sticky-state')
            });
          }
          header.setAttribute('sticky', 'always');
          if (this.hasAttribute('data-home')) header.setAttribute('transparent', 'not-sticky');
          this.stateObserver?.disconnect();
          this.stateObserver = new MutationObserver(this.updateScroll);
          this.stateObserver.observe(header, { attributes: true, attributeFilter: ['data-sticky-state'] });
          this.updateScroll();
          this.heightObserver.observe(header);
          this.updateHeight();
        };
        this.updateScroll = () => {
          if (!this.header || !this.isConnected) return;
          const wrapper = document.querySelector('.page-wrapper');
          const desktop = window.matchMedia('(min-width: 990px)').matches;
          const scrollTop = desktop && wrapper ? wrapper.scrollTop : (document.scrollingElement?.scrollTop || 0);
          const scrolled = scrollTop > 4;
          this.header.toggleAttribute('data-tptc-scrolled', scrolled);
          const state = scrolled ? 'active' : 'inactive';
          if (this.header.getAttribute('data-sticky-state') !== state) {
            this.header.setAttribute('data-sticky-state', state);
          }
        };
        this.startLayout = () => {
          if (!this.isConnected) return;
          this.bindHeader();
          this.scrollWrapper = document.querySelector('.page-wrapper');
          this.scrollWrapper?.addEventListener('scroll', this.updateScroll, { passive: true });
          document.addEventListener('scroll', this.updateScroll, { passive: true });
          window.addEventListener('resize', this.updateScroll, { passive: true });
          const group = document.querySelector('#header-group');
          if (group) {
            this.headerObserver = new MutationObserver(this.bindHeader);
            this.headerObserver.observe(group, { childList: true, subtree: true });
          }
          this.updateHeight();
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.startLayout, { once: true });
        } else this.startLayout();
        this.updateHeight();
        this.button = this.querySelector('.tptc-news-ticker__pause');
        this.onToggle = () => {
          const paused = this.toggleAttribute('data-paused');
          this.button.setAttribute('aria-pressed', String(paused));
        };
        this.button?.addEventListener('click', this.onToggle);
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onToggle);
        this.heightObserver?.disconnect();
        this.headerObserver?.disconnect();
        this.stateObserver?.disconnect();
        this.scrollWrapper?.removeEventListener('scroll', this.updateScroll);
        document.removeEventListener('scroll', this.updateScroll);
        window.removeEventListener('resize', this.updateScroll);
        document.removeEventListener('DOMContentLoaded', this.startLayout);
        this.originalHeaders?.forEach((attributes, header) => {
          header.removeAttribute('data-tptc-scrolled');
          for (const [name, value] of Object.entries(attributes)) {
            if (value === null) header.removeAttribute(name);
            else header.setAttribute(name, value);
          }
        });
        const remaining = document.querySelector('tptc-news-ticker');
        if (!remaining) {
          document.documentElement.style.removeProperty('--tptc-news-ticker-height');
          document.documentElement.style.removeProperty('--tptc-header-stack-height');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tptc-responsive-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tptc-responsive-video')) {
    customElements.define(
      'tptc-responsive-video',
      class TptcResponsiveVideo extends HTMLElement {
        connectedCallback() {
          this.desktopQuery = window.matchMedia('(min-width: 750px)');
          this.isNear = false;
          this.enforceControls = () => {
            this.querySelectorAll('.tptc-video-section__media[data-controls]').forEach((media) => {
              const video = media.querySelector('video');
              if (!video) return;
              const enabled = media.dataset.controls === 'true';
              if (video.controls !== enabled) video.controls = enabled;
              if (!enabled && video.hasAttribute('controls')) video.removeAttribute('controls');
              if (!enabled) video.setAttribute('playsinline', '');
            });
          };
          this.enforceControls();
          this.controlsObserver = new MutationObserver(this.enforceControls);
          this.controlsObserver.observe(this, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['controls', 'data-controls']
          });
          this.addEventListener('loadedmetadata', this.enforceControls, true);
          this.addEventListener('play', this.enforceControls, true);
          this.addEventListener('pause', this.enforceControls, true);
          this.handleViewportChange = this.updatePlayback.bind(this);
          this.handleVisibilityChange = this.updatePlayback.bind(this);
          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.isNear = entry.isIntersecting;
              this.updatePlayback();
            },
            { rootMargin: '400px 0px', threshold: 0 }
          );

          this.visibilityObserver = new IntersectionObserver(
            ([entry]) => {
              this.isVisible = entry.isIntersecting;
              this.updatePlayback();
            },
            { threshold: 0.01 }
          );
          this.panel = this.closest('.shopify-section');
          this.panelObserver = new MutationObserver(this.handleViewportChange);
          if (this.panel) {
            this.panelObserver.observe(this.panel, {
              attributes: true,
              attributeFilter: ['class', 'inert']
            });
          }

          this.desktopQuery.addEventListener('change', this.handleViewportChange);
          document.addEventListener('visibilitychange', this.handleVisibilityChange);
          this.observer.observe(this);
          this.visibilityObserver.observe(this);
        }

        disconnectedCallback() {
          this.desktopQuery?.removeEventListener('change', this.handleViewportChange);
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
          this.observer?.disconnect();
          this.visibilityObserver?.disconnect();
          this.panelObserver?.disconnect();
          this.controlsObserver?.disconnect();
          this.removeEventListener('loadedmetadata', this.enforceControls, true);
          this.removeEventListener('play', this.enforceControls, true);
          this.removeEventListener('pause', this.enforceControls, true);
          this.querySelectorAll('video').forEach((video) => video.pause());
        }

        updatePlayback() {
          this.enforceControls();
          const desktopMedia = this.querySelector('.tptc-video-section__media--desktop');
          const mobileMedia = this.querySelector('.tptc-video-section__media--mobile');
          const activeMedia = this.desktopQuery.matches ? desktopMedia : mobileMedia;
          const inactiveMedia = this.desktopQuery.matches ? mobileMedia : desktopMedia;
          const activeVideo = activeMedia?.querySelector('video');
          const inactiveVideo = inactiveMedia?.querySelector('video');

          inactiveVideo?.pause();
          if (!activeVideo) return;

          const stacked = this.panel?.classList.contains('tptc-stack-panel');
          const activePanel = this.panel?.classList.contains('tptc-stack-panel--active');
          const nextPanel = stacked && !this.panel.hasAttribute('inert');
          if (this.isNear && (!stacked || activePanel || nextPanel)) {
            activeVideo.preload = 'metadata';
          }

          if (document.hidden || !this.isVisible || (stacked && !activePanel)) {
            activeVideo.pause();
            return;
          }

          if (activeMedia.dataset.autoplay !== 'true') return;
          activeVideo.muted = true;
          activeVideo.playsInline = true;
          if (activeVideo.paused && !this.playPending) {
            this.playPending = true;
            activeVideo.play().catch(() => {
              this.enforceControls();
            }).finally(() => {
              this.playPending = false;
            });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tptc-whatsapp-button"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tptc-whatsapp-launcher')) {
    customElements.define('tptc-whatsapp-launcher', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.tptc-whatsapp-button');
        if (this.button) document.body.appendChild(this.button);
      }
      disconnectedCallback() {
        this.button?.remove();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
